/**
 * Links van bronnen die we moeten noemen, los van een component, zodat een
 * kale pagina (privacy) ze kan gebruiken zonder de kaartlade te laden.
 */

/** CC BY 4.0: 3DBAG, de terrassen van de gemeente, het CBS en MET Norway. */
export const BRON_LICENTIE = 'https://creativecommons.org/licenses/by/4.0/'

/** GeoNames, CC BY 4.0: de plekkenlijst van een trip (W34). */
export const BRON_GEONAMES = 'https://www.geonames.org/'
